// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1d7It","modalFooterButton":"ModalNotes_modalFooterButton__2_phF"};